import { DataCollectionEventNames } from '../../../JWeb/JWebEnums';
import { CDMEventData, DataValveCDMEventData } from '../../../JWeb/types';
import {
  DataValveCDMEvent,
  PublishCdmEventsOptions,
  AnalyticsServiceInputType
} from '../../types';
import IAnalyticsService from '../../IAnalyticsService';
import { hasErrorInEventServicePublisher } from '../WebAnalyticsService/dependencies/utils';
import { internalLogger } from '../../../../interface/v1/clientOsLogger';
import BaseAnalyticsService from '../shared/BaseAnalyticsService';

/**
 * NativeAnalyticsService - Analytics service for native platforms without visitUUID handling.
 *
 * This strategy is used for native (JWeb) platforms where:
 * - No visitContextRaw event is sent
 * - No visitUUID cookie/ValueStore management is needed
 * - CDM events are published directly through the native event service
 */
export default class NativeAnalyticsService extends BaseAnalyticsService {
  constructor(analyticsProps: AnalyticsServiceInputType) {
    super(analyticsProps);
  }

  public async init(): Promise<void> {
    // Get Publisher - for native, uses event service directly
    this._publisher = this._events;

    // Checking if all JWEB dependences are ready.
    this.isEnabledWithAllPlugins();

    // Subscribe Events
    this._subscribeEvents();
  }

  public async publishCdmEvents(
    events: DataValveCDMEvent[],
    options?: PublishCdmEventsOptions
  ): Promise<void> {
    try {
      if (!this.isEnabled()) return;

      if (hasErrorInEventServicePublisher(this._publisher)) return;

      internalLogger?.debug?.('Analytics: Publisher was found.');

      await this._writeAnalyticsDataToValueStore(options);

      const eventName = DataCollectionEventNames.cdmEvent;
      const eventData: DataValveCDMEventData = {
        events: events as unknown as [CDMEventData],
        trackingIdentifier: options?.metadata?.trackingIdentifier
        // Note: Native does not include valveControllerMetadata
      };

      // Publishes event
      internalLogger?.debug?.(
        'Analytics: publishCdmEvents is calling Publish method. '
      );
      await this._publisher.publish(eventName, eventData);
    } catch (e) {
      internalLogger?.error?.('Analytics: publishCdmEvents Internal Error', e);
    }
  }
}
